module.exports = __webpack_public_path__ + "../resources/images/createlink-17d7b9207a0195851fd0ce3a0c1cdf08.svg";